"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  box-sizing: content-box;\n  display: inline-flex;\n  position: relative;\n  transition-delay: 150ms;\n  transition: margin ease 300ms;\n  flex-shrink:0;\n\n  &:not(:only-of-type),\n  & ~ &:not(:first-of-type) {\n    margin-", ": ", "px;\n  }\n\n  &:last-of-type {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = (0, _styledComponents.default)('div').withConfig({
  displayName: "AvatarWrapper",
  componentId: "tk5gpl-0"
})(_templateObject(), function (props) {
  return props._isListReversed ? 'left' : 'right';
}, function (props) {
  return -1 * props.overlapOffset;
}, function (props) {
  return props._isListReversed && 'margin-left: 0 !important;';
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2401/js/UIAvatarDisplay/baseStyledComponents/AvatarWrapper.js
// module id = 420
// module chunks = 209 210 211 212